import React, { useEffect, useState } from "react";
import { Card, Spinner, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";

import CustomPagination from "Common/customPagination";
import { authServices } from "Utils/auth/services";
import EventReportTable from "Common/Tables/eventWiseTable/eventReportTable";

interface EventPlPayload {
  search?: {
    sport_id?: string;
  };
  from_date: string;
  to_date: string;
  // page: number;
  // limit: number;
}

const EventReport: React.FC = () => {
  const { sport_id, from_date, to_date } = useParams<{
    marketid: string;
    matchname: string;
    type: string;
    sport_id: string;
    from_date: string;
    to_date: string;
  }>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [casinoBetsData, setCasinoBetsData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(50);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const getEventPlData = async (page: number = 1) => {
    if (!sport_id || !from_date || !to_date) return;

    setIsLoading(true);
    try {
      const payload: EventPlPayload = {
        search: {
          sport_id: sport_id,
        },
        from_date,
        to_date,
        // page,
        // limit: itemsPerPage,
      };

      const { response } = await authServices.eventWisePlReport(payload);
     
      if (response?.data) {
        setCasinoBetsData(response.data);
        setTotalItems(response?.total || 0);
      } else {
        setCasinoBetsData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching casino bets data:", error);
      setCasinoBetsData([]);
      setTotalItems(0);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getEventPlData(page);
  };

  const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newItemsPerPage = Number(event.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
    getEventPlData(1);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  const filteredData = searchTerm
    ? casinoBetsData.filter((item) =>
        item.sport_name?.toLowerCase().includes(searchTerm.toLowerCase()) || 
        item.series_name?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : casinoBetsData;

  const handleRowClick = (matchId: string, matchName: string) => {
    const url = `/matchreport/${matchId}/${matchName}/${sport_id}/${from_date}/${to_date}`;
    window.open(url, "_blank");
  };

  useEffect(() => {
    getEventPlData(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sport_id, from_date, to_date, itemsPerPage]);

  return (
    <div className="event-pl">
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex gap-2 align-items-center">
              Show
              <select
                className="form-select w-auto"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
              </select>
              Entries
            </div>

            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="w-25"
            />
          </div>

          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <>
              {/* Pass the searchTerm to EventReportTable */}
              <EventReportTable
                fancyPLData={filteredData}
                total={totalItems} // Replace with dynamic total if needed
                onClickRow={handleRowClick}
                searchTerm={searchTerm} // Pass the searchTerm as a prop
              />
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default EventReport;
